<modal id="successful-sending">
	<div class="modal">
		<div class="modal__block-icon">
			<img class="modal__cross" (click)="closeModal('successful-sending');" src="assets/images/education/icons/icon__cross--white.svg" alt="">
		</div>
		<div class="modal__inner">
			<div class="modal__message">Твоя заявка отправлена</div>
			
			<img class="modal__image" src="assets/images/education/icons/icon__congratulation.svg">
		</div>
	</div>
	<div class="modal__background" (click)="closeModal('successful-sending');"></div>
</modal>
